module.exports = __webpack_public_path__ + "static/media/big-hall.aa790c16.svg";